import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import MinimumDistanceSlider from './MinimumDistanceSlider';
import ClientProvider from './client';
export default createDemo(import.meta.url, MinimumDistanceSlider, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/slider/demos/minimum-distance/MinimumDistanceSlider.tsx",
    "fileName": "MinimumDistanceSlider.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Slider from '@mui/material/Slider';\n\nfunction valuetext(value: number) {\n  return `${value}°C`;\n}\n\nconst minDistance = 10;\n\nexport default function MinimumDistanceSlider() {\n  const [value1, setValue1] = React.useState<number[]>([20, 37]);\n\n  const handleChange1 = (event: Event, newValue: number[], activeThumb: number) => {\n    if (activeThumb === 0) {\n      setValue1([Math.min(newValue[0], value1[1] - minDistance), value1[1]]);\n    } else {\n      setValue1([value1[0], Math.max(newValue[1], value1[0] + minDistance)]);\n    }\n  };\n\n  const [value2, setValue2] = React.useState<number[]>([20, 37]);\n\n  const handleChange2 = (event: Event, newValue: number[], activeThumb: number) => {\n    if (newValue[1] - newValue[0] < minDistance) {\n      if (activeThumb === 0) {\n        const clamped = Math.min(newValue[0], 100 - minDistance);\n        setValue2([clamped, clamped + minDistance]);\n      } else {\n        const clamped = Math.max(newValue[1], minDistance);\n        setValue2([clamped - minDistance, clamped]);\n      }\n    } else {\n      setValue2(newValue);\n    }\n  };\n\n  return (\n    <Box sx={{ width: 300 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Slider\n        getAriaLabel={() => 'Minimum distance'}\n        value={value1}\n        onChange={handleChange1}\n        valueLabelDisplay=\"auto\"\n        getAriaValueText={valuetext}\n        disableSwap\n      />\n      <Slider\n        getAriaLabel={() => 'Minimum distance shift'}\n        value={value2}\n        onChange={handleChange2}\n        valueLabelDisplay=\"auto\"\n        getAriaValueText={valuetext}\n        disableSwap\n      />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 58,
        "focusedLines": 16,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Slider from '@mui/material/Slider';\n\nfunction valuetext(value: number) {\n  return `${value}°C`;\n}\n\nconst minDistance = 10;\n\nexport default function MinimumDistanceSlider() {\n  const [value1, setValue1] = React.useState<number[]>([20, 37]);\n\n  const handleChange1 = (event: Event, newValue: number[], activeThumb: number) => {\n    if (activeThumb === 0) {\n      setValue1([Math.min(newValue[0], value1[1] - minDistance), value1[1]]);\n    } else {\n      setValue1([value1[0], Math.max(newValue[1], value1[0] + minDistance)]);\n    }\n  };\n\n  const [value2, setValue2] = React.useState<number[]>([20, 37]);\n\n  const handleChange2 = (event: Event, newValue: number[], activeThumb: number) => {\n    if (newValue[1] - newValue[0] < minDistance) {\n      if (activeThumb === 0) {\n        const clamped = Math.min(newValue[0], 100 - minDistance);\n        setValue2([clamped, clamped + minDistance]);\n      } else {\n        const clamped = Math.max(newValue[1], minDistance);\n        setValue2([clamped - minDistance, clamped]);\n      }\n    } else {\n      setValue2(newValue);\n    }\n  };\n\n  return (\n    <Box sx={{ width: 300 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Slider\n        getAriaLabel={() => 'Minimum distance'}\n        value={value1}\n        onChange={handleChange1}\n        valueLabelDisplay=\"auto\"\n        getAriaValueText={valuetext}\n        disableSwap\n      />\n      <Slider\n        getAriaLabel={() => 'Minimum distance shift'}\n        value={value2}\n        onChange={handleChange2}\n        valueLabelDisplay=\"auto\"\n        getAriaValueText={valuetext}\n        disableSwap\n      />\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 40
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Slider"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 41
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "getAriaLabel"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "() ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "Minimum distance",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 42
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "value1"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 43
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "onChange"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "handleChange1"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 44
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "valueLabelDisplay"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "auto",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 45
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "getAriaValueText"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "valuetext"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 46
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "disableSwap"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 47
            },
            "      />"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 48
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Slider"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 49
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "getAriaLabel"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "() ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "Minimum distance shift",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 50
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "value2"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 51
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "onChange"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "handleChange2"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 52
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "valueLabelDisplay"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "auto",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 53
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "getAriaValueText"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "valuetext"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 54
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "disableSwap"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 55
            },
            "      />"
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 58,
    "focusedLines": 16,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/Slider"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
